import { HomeContactChoice } from '../HomeContactChoice';
import { PhonePriceNote } from './PhonePriceNote';

export const SellContactSupport = ({ idPrefix }) => (
  <section className="relative border-t border-slate-200 bg-white px-3 py-3 sm:px-5"
    data-testid={`${idPrefix}-support`}>
    <PhonePriceNote idPrefix={idPrefix} className="mb-3" />
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
      <p className="text-sm font-medium text-slate-600" data-testid={`${idPrefix}-support-label`}>Need a hand?</p>
      <div className="w-full min-[380px]:w-auto">
        <HomeContactChoice kind="sell" idPrefix={idPrefix} appearance="button" />
      </div>
    </div>
  </section>
);
